import React from 'react';
import { ImageFile } from '~/data/types/images';

const mailIconIcon: React.FC<ImageFile> = ({
  className,
  style,
  Component = 'svg',
}) => {
  return (
    <Component
      className={className}
      style={style}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3329 7.375L11.6301 10.3859C10.9305 10.9409 9.94626 10.9409 9.24668 10.3859L5.5127 7.375"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5051 17.5C17.0396 17.507 18.7477 15.4246 18.7477 12.8653V7.14168C18.7477 4.58235 17.0396 2.5 14.5051 2.5H6.32367C3.78921 2.5 2.08105 4.58235 2.08105 7.14168V12.8653C2.08105 15.4246 3.78921 17.507 6.32367 17.5H14.5051Z"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Component>
  );
};

export default mailIconIcon;
